module.exports = __webpack_public_path__ + "img/empty-address.1a244e44.png";